<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>库存管理</el-breadcrumb-item>
      <el-breadcrumb-item>库存列表</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片视图区域 -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="3.3">
          <el-date-picker
            v-model="value1"
            @change="selectTime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择日期时间">
          </el-date-picker>
        </el-col>
        <el-col :span="8">
          <el-input placeholder="请输入商品名称" v-model="queryInfo.query" clearable @clear="getGoodsList">
            <el-button slot="append" icon="el-icon-search" @click="getGoodsList"></el-button>
          </el-input>
        </el-col>
        <!-- <el-col :span="4">
          <el-button type="primary" @click="goAddpage">添加商品</el-button>
        </el-col>
        <el-col :span="4">
          <el-button type="info" @click="goToSetEndTime">设置低温商品截止时间</el-button>
        </el-col> -->
        <el-col :span="2" v-if="canLook == 1">
          <a class="aaaa" :href="exportUrl + '&tid=' + queryInfo.tid + '&qTime='+queryInfo.qTime">
            <el-button size="mini" type="info">导出表格</el-button>
          </a>
        </el-col>
      </el-row>

      <el-table :data="goodslist" border stripe @filter-change="handleFilterChange" @selection-change="handleSelectionChange">
        <el-table-column fixed type="selection" width="55"> </el-table-column>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="商品名称" prop="title"></el-table-column>

        <el-table-column align="center" width="150px">
          <!-- slot-scope="scope" -->
          <template slot="header" slot-scope="scope">
            <el-select v-model="typeValue" size="mini" @change="changeType" placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </template>
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.type == '常温商品'">常温商品</el-tag>
            <el-tag class="info" v-if="scope.row.type == '低温商品'">低温商品</el-tag>
          </template>
        </el-table-column>

        <!-- <el-table-column :label="typeTxt" align="center" :filter-multiple="false" :column-key="'type'" :filters="filterStatus" prop="type" width="100px"></el-table-column> -->
        <el-table-column label="编号" prop="number" width="100px"></el-table-column>

        <el-table-column label="封面" width="120px" align="center">
          <template slot-scope="scope">
            <el-image style="width: 100px; height: 100px" :src="scope.row.fengmian" fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="价格（元）" align="center" prop="price" width="80px"></el-table-column>
        <el-table-column label="库存" align="center" prop="kucun" width="70px"></el-table-column>
        <el-table-column label="库存预警" align="center" prop="warnNum" width="70px"></el-table-column>

        <el-table-column label="单位" width="60px">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.unit == '1'">件</el-tag>
            <el-tag class="info" v-if="scope.row.unit == '2'">组</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="上架状态" width="90px">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == '1'">已上架</el-tag>
            <el-tag class="info" v-if="scope.row.status == '0'">未上架</el-tag>
          </template>
        </el-table-column>

        <el-table-column label="操作" v-if="canLook == 1 && btnShow">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" v-if="scope.row.type == '常温商品'" size="mini" @click="editById(scope.row)"></el-button>
            <!-- <el-button type="info" icon="el-icon-info" v-if="scope.row.type == '常温商品'" size="mini" @click="editHistory(scope.row.id)">操作记录</el-button> -->
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </el-card>

    <!-- 修改地址的对话框 -->
    <el-dialog title="修改库存" :visible.sync="changeKucunVisible" width="50%" @close="changeKucunDialogClosed">
      <el-form :model="changeKucunForm" :rules="changeKucunFormRules" ref="changeKucunFormRef" label-width="100px">
        <el-form-item label="现有库存数" prop="kucun">
          <el-input v-model="changeKucunForm.kucun" disabled></el-input>
        </el-form-item>

        <el-form-item label="增加/减少" prop="kucun">
          <el-radio v-model="changeKucunForm.addtip" label="add">增加</el-radio>
          <el-radio v-model="changeKucunForm.addtip" label="reduce">减少</el-radio>
        </el-form-item>

        <el-form-item label="修改库存数" prop="changekun">
          <el-input v-model="changeKucunForm.changekun"></el-input>
        </el-form-item>

        <el-form-item label="库存预警数" prop="warnNum">
          <el-input v-model="changeKucunForm.warnNum"></el-input>
        </el-form-item>

        <el-form-item label="备注" prop="changeBeizhu">
          <el-input v-model="changeKucunForm.changeBeizhu"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="changeKucunVisible = false">取 消</el-button>
        <el-button type="primary" @click="sureChangeKucun">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      canLook: 1,
      queryInfo: {
        query: '',
        pagenum: 1,
        pagesize: 10,
        tid: 0,
        qTime:'',
      },
      exportUrl: 'https://hsapi.hsxsn.cn///exportKucunList?mPhone=' + localStorage.getItem('phone'),

      typeTxt: "商品类型",
      filterStatus: [
        { text: '常温产品', value: 1 },
        { text: '低温产品', value: 2 }],

      typeValue: "商品类型",
      options: [
        { label: '商品类型', value: 0 },
        { label: '常温产品', value: 1 },
        { label: '低温产品', value: 2 },
      ],
      changeKucunForm: {
        id: null,
        kucun: null,
        changekun: null,
        changeBeizhu: null,
        warnNum: null,
        addtip: 'add',
      },
      changeKucunVisible: false,
      changeKucunFormRules: {
        changekun: [
          { required: true, message: '请输入要修改的库存数', trigger: 'blur' }
        ],
        changeBeizhu: [
          { required: true, message: '请填写修改备注信息', trigger: 'blur' }
        ],
        warnNum: [
          { required: true, message: '请输入库存预警', trigger: 'blur' }
        ]
      },
      // 商品列表
      goodslist: [],
      // 总数据条数
      total: 0,
      multipleSelection: [],
      multipleSelectionjson: null,
      value1: '',
      btnShow:true,
    }
  },


  created () {
    this.getGoodsList()
  },

  methods: {

    changeType (value) {
      console.log(value);
      this.queryInfo.tid = value
      this.queryInfo.pagenum = 1
      this.getGoodsList(); // 通过接口获取数据的方法
    },

    // 多选选择的项
    handleSelectionChange (val) {

      this.multipleSelection = [];
      val.forEach(element => {
        this.multipleSelection.push({ 'id': element.id });
      });
      console.log(this.multipleSelection.length)
      if (this.multipleSelection.length > 0) {
        this.multipleSelectionjson = JSON.stringify(this.multipleSelection);
        this.exportUrl = 'https://hsapi.hsxsn.cn//exportKucunList?data=' + this.multipleSelectionjson + '&mPhone=' + localStorage.getItem('phone')
          + '&mPhone=' + localStorage.getItem('phone')
      } else {
        this.multipleSelectionjson = null;
        this.exportUrl = 'https://hsapi.hsxsn.cn//exportKucunList?mPhone=' + localStorage.getItem('phone')
      }
    },

    handleFilterChange (filters) {
      console.log(filters);
      if (filters.type.length > 0) {
        this.queryInfo.tid = filters.type[0]
        if (this.queryInfo.tid == 1) {
          this.typeTxt = "常温商品"
        } else if (this.queryInfo.tid == 2) {
          this.typeTxt = "低温商品"
        } else {
          this.typeTxt = "商品类型"
        }
      } else {
        this.queryInfo.tid = 0;
        this.typeTxt = "商品类型"
        console.log(this.queryInfo);
      }
      this.getGoodsList(); // 通过接口获取数据的方法
    },

    /**
    * @description: 选择查询时间点
    */
    selectTime(val){
      this.queryInfo.qTime=val/1000;
        // console.log(this.queryInfo,'565656565656');
        if(val){
          this.btnShow=false;
            // this.filters.year = val.split('-')[0]
            // this.filters.month = val.split('-')[1]
        }else{
            this.btnShow=true;
        }
    },

    // 根据分页获取对应的商品列表
    async getGoodsList () {
      console.log(this.queryInfo);
      const { data: res } = await this.$http.get('admin/good/allKucunList', {
        params: this.queryInfo
      })

      if (res.code !== 200) {
        return this.$message.error('获取商品列表失败！')
      }

      this.$message.success('获取商品列表成功！')
      console.log(res.result)
      this.goodslist = res.result.list
      this.total = res.result.count
      if (window.sessionStorage.getItem('pathCanLook') == 2) { //仅查看
        this.canLook = 2
      }
    },

    handleSizeChange (newSize) {
      this.queryInfo.pagesize = newSize
      this.getGoodsList()
    },
    handleCurrentChange (newPage) {
      this.queryInfo.pagenum = newPage
      this.getGoodsList()
    },

    async removeById (id) {
      const confirmResult = await this.$confirm(
        '此操作将永久删除该商品, 是否继续?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }
      ).catch(err => err)
      if (confirmResult !== 'confirm') {
        return this.$message.info('已经取消删除！')
      }

      const { data: res } = await this.$http.delete(`goods/${id}`)

      if (res.meta.status !== 200) {
        return this.$message.error('删除失败！')
      }

      this.$message.success('删除成功！')
      this.getGoodsList()
    },

    // 监听 switch 开关状态的改变
    async goodStateChanged (userinfo) {
      console.log(userinfo)
      const { data: res } = await this.$http.post('/admin/good/updateStatus', {
        status: userinfo.status,
        id: userinfo.id
      })
      if (res.code !== 200) {
        userinfo.mg_state = !userinfo.mg_state
        return this.$message.error('更新商品状态失败！')
      }
      this.$message.success('更新商品状态成功！')
    },

    goAddpage () {
      this.$router.push('/goods/add')
    },

    // 操作记录
    editHistory (id) {
      // this.$router.push('/kucun/editHistory')
      this.$router.push({ path: '/kucun/editHistory', query: { id: id } })

    },

    // 编辑
    editById (row) {
      console.log(row);
      this.changeKucunForm.id = row.id;
      this.changeKucunForm.kucun = row.kucun;
      this.changeKucunForm.warnNum = row.warnNum;
      this.changeKucunVisible = true;
      // this.$router.push({ path: '/goods/add', query: { id: id } })

    },
    // 修改库存请求
    async sureChangeKucun () {
      this.$refs.changeKucunFormRef.validate(async valid => {
        if (!valid) return

        var phone = window.sessionStorage.getItem('phone')

        const { data: res } = await this.$http.post('/admin/good/changeKucun', {
          changeBeizhu: this.changeKucunForm.changeBeizhu,
          addtip: this.changeKucunForm.addtip,
          kucun: this.changeKucunForm.kucun,
          changekucun: this.changeKucunForm.changekun,
          id: this.changeKucunForm.id,
          warnNum: this.changeKucunForm.warnNum,
          phone: phone,
        })
        if (res.code !== 200) {
          this.changeKucunForm.changeBeizhu = null;
          this.changeKucunForm.changekun = null;
          return this.$message.error('更新商品失败！')
        }

        this.$message.success('更新商品成功！');
        this.changeKucunVisible = false;
        this.changeKucunForm.changeBeizhu = null;
        this.changeKucunForm.changekun = null;
        this.getGoodsList();
      })
    },

    changeKucunDialogClosed () {
      this.changeKucunVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
.el-select {
  width: 135px;
}
</style>
